module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title0":"Market Announcements","title1":"Latest Market Announcements"},"ar":{"title0":"أخبار السوق","title1":"أحدث أخبار السوق"}}')
  delete Component.options._Ctor
}
